export default __webpack_public_path__ + "static/media/oauth.afadba5e.webp";